import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { SolLayoutComponent } from '../sol-layout/sol-layout.component';
import { SolSelectValue } from '../../../models/core/sol-select-value';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { SolIconComponent } from '../sol-icon/sol-icon.component';
import { SolLayout } from '../../../models/core/sol-layout';
import { SolButtonGroup, SolButtonGroupSize } from '../../../models/core/sol-button-group';

@Component({
  selector: 'sol-button-group',
  imports: [SolLayoutComponent, TranslatePipe, SolIconComponent],
  templateUrl: './sol-button-group.component.html',
})
export class SolButtonGroupComponent extends AbstractComponent<SolButtonGroup> {
  // Computed
  protected readonly hostClass$ = this.compute(state => state.hostClass);
  protected readonly disabled$ = this.compute(state => state.disabled);
  protected readonly buttons$ = this.compute(state => state.buttons);
  protected readonly size$ = this.compute(state => state.size);
  protected readonly layout$ = this.compute(state => state.layout);

  // Events
  @Output('value')
  public valueEmitter = new EventEmitter<string | undefined>();

  constructor() {
    super(SolButtonGroup.of());
  }

  @HostBinding('class')
  public get hostClass(): string {
    return this.hostClass$();
  }

  // Input
  @Input()
  public set buttonGroup(buttonGroup: SolButtonGroup) {
    this.patch(buttonGroup);
  }

  @Input()
  public set disabled(disabled: boolean) {
    this.update(state => state.withDisabled(disabled));
  }

  @Input()
  public set value(value: string | undefined) {
    this.update(state => state.withValue(value));
  }

  @Input()
  public set availableValues(availableValues: SolSelectValue[]) {
    this.update(state => state.withAvailableValues(availableValues));
  }

  @Input()
  public set size(size: SolButtonGroupSize) {
    this.update(state => state.withSize(size));
  }

  @Input()
  public set layout(layout: SolLayout) {
    this.update(state => state.withLayout(layout));
  }

  public onSelect(event: MouseEvent, id: string | undefined): void {
    const state = this.state;
    if (state.disabled) {
      return;
    }

    const option = state.availableValues.find(value => value.id === id);
    if (option?.disabled) {
      return;
    }

    if (state.value === id) {
      return;
    }

    event.stopPropagation();
    this.valueEmitter.emit(id);
  }
}
